import React from 'react';
import ButtonAction from "../components/ButtonAction";
import {usePopupPriceCatalogContext} from "../../PriceQuoteDetails/contexts/PopupPriceCatalogContext";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";

export function PriceCatalogActionColumnFormatter(cellContent) {
  const {handleGetCatalogData} = usePopupPriceCatalogContext();
  const servicePrice = cellContent?.servicePrice ?? 0;
  const serviceDescription = cellContent?.serviceDescription ?? '';
  return (
    <div className={'d-flex justify-content-end'}>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'primary'}
        label={
          <img
            src={toAbsoluteUrl('/media/common/Check_circle_primary.svg')}
            alt="i" height={24}
          />
        }
        onClick={() => handleGetCatalogData(servicePrice, serviceDescription)}
      />
    </div>
  );
}